import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next'; // I18N
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import About from '../../components/about/about';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Logo from '../../images/logo2.png'
const AboutPage = () => {
    const { t } = useTranslation(); // I18N
    return (
        <Fragment>
            <Navbar Logo={Logo} hclass={'wpo-site-header-s3'} />
            <PageTitle pageTitle={t('pageTitles.about')} pagesub={t('pageTitles.aboutSub')} />
            <About />
            
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default AboutPage;
